// Drag handle for resizing a table column. Sits on the right edge of
// a column header cell and updates the parent's per-column width
// override on pointer drag. Mirrors the resizer used elsewhere in the
// dashboard (sidebar, detail panel) — wider hit-target than the
// visible 2px line so the handle is forgiving without being noisy.

import { useRef } from "react";

export default function ColumnResizeHandle({ onResize, currentWidth }) {
    const startRef = useRef({ x: 0, w: 0, active: false });

    function onPointerDown(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        startRef.current = { x: e.clientX, w: currentWidth, active: true };
        document.body.style.cursor = "ew-resize";
        document.body.classList.add("is-resizing-column");

        const onMove = (ev) => {
            if (!startRef.current.active) return;
            const dx = ev.clientX - startRef.current.x;
            onResize(startRef.current.w + dx);
        };
        const onUp = () => {
            startRef.current.active = false;
            document.body.style.cursor = "";
            document.body.classList.remove("is-resizing-column");
            window.removeEventListener("pointermove", onMove);
            window.removeEventListener("pointerup", onUp);
            window.removeEventListener("pointercancel", onUp);
        };
        window.addEventListener("pointermove", onMove);
        window.addEventListener("pointerup", onUp);
        window.addEventListener("pointercancel", onUp);
    }

    return (
        <span
            role="separator"
            aria-orientation="vertical"
            aria-label="Resize column"
            onPointerDown={onPointerDown}
            className="absolute top-0 bottom-0 right-[-4px] z-[2] w-[8px] cursor-ew-resize select-none touch-none group/resizer"
        >
            <span
                aria-hidden="true"
                className="absolute top-[2px] bottom-[2px] left-[3px] w-[2px] bg-transparent group-hover/resizer:bg-[color:var(--line-strong)] transition-colors"
            />
        </span>
    );
}
